import { getApi } from 'apis';

const getEmployeeTimeActivitiesByStaffCode = async (data: any) => {
	return await getApi(`/timeActivities/details/monthly`, data);
};
const getEmployeeTimeActivitiesDayWise = async (data: any) => {
	return await getApi(`/timeActivities/day-wise`, data);
};

export const timeActivitiesApi = {
	getEmployeeTimeActivitiesByStaffCode,
	getEmployeeTimeActivitiesDayWise,
};
